import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { invoiceAPI } from 'redux/invoiceAPI';
import { FetchingState } from '@payer-admin-ui/components-v2/src/types/state';
import { LocalDate } from '@payer-admin-ui/api/src/external/java/LocalDate';
import { AddManualInvoicePaymentResponse } from '@payer-admin-ui/api/src/invoices/responses/AddManualInvoicePaymentResponse';

export const badDebt = createAsyncThunk<
  AddManualInvoicePaymentResponse,
  { invoiceNumber: number; externalReference: string; bookingDate?: LocalDate }
>('invoices/actions/BadDebtModal/badDebt', async ({ invoiceNumber, externalReference, bookingDate }) => {
  return invoiceAPI.actions.badDebt({
    invoiceNumber,
    externalReference,
    bookingDate,
  });
});

const initialState: FetchingState = {
  isFetching: false,
  success: undefined,
  error: null,
};

const badDebtModalSlice = createSlice({
  name: 'invoices/actions/badDebtModal',
  initialState,
  reducers: {
    reset: _state => initialState,
  },
  extraReducers: builder => {
    builder.addCase(badDebt.pending, () => ({ isFetching: true, success: undefined, error: null }));
    builder.addCase(badDebt.fulfilled, () => ({
      isFetching: false,
      success: true,
      error: null,
    }));
    builder.addCase(badDebt.rejected, (_, { error }) => ({
      isFetching: false,
      success: false,
      error,
    }));
  },
});

export const {
  actions: { reset },
  reducer: badDebtModalReducer,
} = badDebtModalSlice;
